import {Subscription} from 'rxjs';

import IPlayer from '../../../Player/Interfaces/IPlayer';

import createConsumerConfigStream from './Streams/createConsumerConfigStream';
import subscribeToConsumerConfig  from './Subscribers/subscribeToConsumerConfig';

const connectConfigSubscriptions = (player: IPlayer): Subscription[] => [
    subscribeToConsumerConfig(createConsumerConfigStream(player.consumerInput.config$), player.state.stores.config)
];

export default connectConfigSubscriptions;